// Selectors
const $qs = selector => document.querySelector(selector)
const $$qsa = selector => document.querySelectorAll(selector)

const FORM = $qs("#form")
const IdForm = $qs("#sendID")
const template = $qs("#result-template")
const selectButton = $qs(".select_button")
const productListWrapper = $qs(".product__list")
const submitButton = $qs(".submit__button")
const inputFields = $$qsa(".input__wrapper input") || []
const selectedList = $qs(".selected_products_list")
const selectedProductsDetails = $qs(".selected_products_list .products_details")
const buttonsToDisable = [submitButton, $qs("button.autofill")]
const filterProductsBtn = $qs(".filter__products")
const selectCollections = $qs(".select__collection")
const selectFilters = $qs(".filters__wrapper")
const backgroundOverlay = $qs(".background-overlay")
const messagePopup = $qs(".message__popup")
const successMessage = $qs(".success__message")
const errorMessage = $qs(".error__message")
const sendingAnimation = $qs(".sending__animation") // SVG animation for sending
let totalPrice = $qs(".selected_products_list .selected_products_total")
const toggleElements = [totalPrice, selectedList]
const selectedFilters = $qs(".selected__filters .filters")

// Product details input fields
const formFields = {
	product: $qs(".input__wrapper #product"),
	price: $qs(".input__wrapper #price"),
	quantity: $qs(".input__wrapper #quantity"),
	total: $qs(".input__wrapper #total")
}

// Validation Patterns
const inputPatterns = {
	"data-mobile": /^[6-9][0-9]{9}$/, // 10 digit number starting from 6-9
	"data-text": /^[a-zA-Z]+$/, // Only Alphabets
	"data-pin": /^[1-9][0-9]{5}$/, // 6 digit number starting from 1-9
	"data-text-space": /^[a-zA-Z ]+$/ // Alphabets and white space
}

// Editable Inputs
const editableInputFields = [...inputFields].filter(input => !input.classList.contains("non_editable"))

// EventListeners
if (submitButton) submitButton.addEventListener("click", () => $qs("#submit__form").click())
if (filterProductsBtn) filterProductsBtn.addEventListener("click", () => applyFilters())
if (selectCollections) selectCollections.addEventListener("change", (e) => chooseCollection(e))
if (selectButton && productListWrapper) selectButton.addEventListener("click", () => selectButtonEvent())
if (backgroundOverlay) backgroundOverlay.addEventListener("click", () => {
	toggleClasses([backgroundOverlay, messagePopup, successMessage, errorMessage], true, "hidden")
})

// FORM SUBMIT
FORM.addEventListener("submit", handleFormSubmit)
IdForm.addEventListener("submit", handleFormSubmit)

// Input validations for Editable fields
if (editableInputFields.length > 0) {
	editableInputFields.forEach(input => {

		// Find if input has anykind of pattern
		const patternKey = Object.keys(inputPatterns).find(key => input.hasAttribute(key))
		const pattern = inputPatterns[patternKey]

		input.addEventListener("input", () => {
			if (pattern && !pattern.test(input.value)) {
				input.setCustomValidity("Input invalid")
				input.setAttribute("invalid", "true")
			} else {
				input.setCustomValidity("")
				input.removeAttribute("invalid")
			}
			input.reportValidity()

			const hasInvalid = [...editableInputFields].some(i => i.hasAttribute("invalid"))
			submitButton.toggleAttribute("disabled", hasInvalid)
		})
	})
}

// Choose collection
function chooseCollection(e) {
	const selectedOption = e.target.value

	if (selectedOption !== "") {
		selectValues(selectedOption)

		// Clear filters and close it
		selectFilters.querySelectorAll("input:checked")?.forEach(option => option.checked = false)
		selectFilters.removeAttribute("open")
	}
}

// Apply filters to products
function applyFilters() {
	const filterOptions = selectFilters.querySelectorAll("input:checked")
	const values = filterOptions.length > 0 ? Array.from(filterOptions).map(option => option.value.trim()) : []
	const results = $$qsa(`.result`)
	selectedFilters.innerHTML = ""

	if (results.length > 0) {
		if (filterOptions.length > 0) {

			selectedFilters.parentElement.classList.remove("hidden")

			values.forEach(filter => {
				const button = document.createElement("button")
				button.classList.add("selected-filter__value")
				button.textContent = filter
				selectedFilters.appendChild(button)
			})

			results.forEach(result => {
				const filterValue = result.getAttribute("data-filters") || ""

				for (const val of values) {
					if (filterValue.includes(val)) {
						result.classList.remove("hidden")
						break
					} else {
						result.classList.add("hidden")
					}
				}
			})
		} else {
			results.forEach(result => result.classList.remove("hidden")) // Show all the results
			selectedFilters.parentElement.classList.add("hidden")
		}
	}
	selectFilters.removeAttribute("open")
}

// Select the chosen product option and adds its details to the form
function selectButtonEvent() {
	const selectedOptions = chooseOption(".productOption")

	if (selectedOptions.length > 0) {
		selectValues()

		// Set default values after products selection
		selectCollections.querySelector("option[data-default]").selected = true
		selectFilters.querySelectorAll("input:checked").forEach(option => option.checked = false)
		selectFilters.removeAttribute("open")

		selectedFilters.innerHTML = ""
		toggleClasses([productListWrapper.parentElement, selectedFilters.parentElement, selectButton], true, "hidden")
	} else {
		alert("Please select a product")
	}
}

/*
## URL FOR FETCHING ONLY PRODUCTS WITH VARIANTS:
`/search/suggest.json?q=${query}&resources[type]=product&resources[options][unavailable_products]=show&resources[options][fields]=variants.sku,title,product_type,variants.title,vendor`
*/

async function selectValues(optionValue = "") {

	// Show all the filters initially
	const filterOptions = selectFilters.querySelectorAll("input");
	if (filterOptions.length > 0) filterOptions.forEach(opt => opt.parentElement.classList.remove("hidden"))

	if (!optionValue) {
		processProductSelections();
		return;
	}

	if (optionValue === "default") {
		toggleClasses([productListWrapper.parentElement, selectButton], true, "hidden");
		return;
	}

	const controller = new AbortController();
	const timeoutID = setTimeout(() => controller.abort(), 20000); // Global timeout
	sendingAnimation.classList.remove("hidden");

	// Recursive fetch with 500-product limit
	function fetchAllProducts(optionValue, page = 1, controller, products = []) {
		const pageTimeout = setTimeout(() => controller.abort(), 10000);

		return fetch(`/collections/${optionValue}/products.json?page=${page}`, {
			signal: controller.signal
		})
			.then(response => {
				clearTimeout(pageTimeout);
				return response.json();
			})
			.then(data => {
				if (page === 1 && data.products.length === 0) {
					alert("No products found.");
					return products;
				}

				products.push(...data.products);

				// Stop if product count hits or exceeds 500
				if (products.length >= 500) {
					console.warn("Stopped fetching after reaching 500 products.");
					return products.slice(0, 500); // Limit 500 product exactly
				}

				if (data.products.length > 0) {
					return fetchAllProducts(optionValue, page + 1, controller, products);
				} else {
					return products;
				}
			})
			.catch(error => {
				if (error.name === "AbortError") {
					alert("Request took too long. Please try again.");
				} else {
					console.error("Error fetching products:", error);
				}
				return products;
			});
	}

	try {
		const allProducts = await fetchAllProducts(optionValue, 1, controller);

		// Flatten all tags into a single array of strings
		const allTags = allProducts.flatMap(prod => prod.tags || []);
		const tagSet = new Set(allTags);

		// Show/hide each filter option based on tag match
		filterOptions.forEach(option => {
			const val = option.value.trim();
			const shouldShow = tagSet.has(val);
			option.parentElement.classList.toggle("hidden", !shouldShow);
		});


		cloneProductTemplate(allProducts);
	} finally {
		clearTimeout(timeoutID);
		sendingAnimation.classList.add("hidden");
	}
}


function processProductSelections() {
	const deselectedOptions = $$qsa(".productOption[auto-checked]")

	// Remove existing products that were manually deselected by unchecking them
	for (const option of deselectedOptions) {

		if (!option.checked) {
			const handle = option.closest(".result").querySelector(".result__handle")

			if (handle) {
				const existingProduct = $qs(`.selected_product_title[data-handle="${handle.textContent}"]`) || ""
				if (existingProduct) existingProduct.parentElement.remove()
			}
		}
	}

	// Render selected products after removing the deselected items
	const selectedOptions = chooseOption(".productOption")
	renderProducts(selectedOptions)
}

// Clone Template element to create product cards
function cloneProductTemplate(products) {

	if (products.length > 0) {
		productListWrapper.innerHTML = "" // Clear all the products...

		products.forEach((product, index) => {
			const clone = template.content.cloneNode(true) // clone the template content
			const resultContainer = clone.querySelector(".result")

			// Reference DOM elements inside the cloned template
			const resultImage = resultContainer.querySelector(".result__image")
			const resultTitle = resultContainer.querySelector(".result__title")
			const resultHandle = resultContainer.querySelector(".result__handle")
			const resultPrice = resultContainer.querySelector(".result__price")
			const resultCompareAtPrice = resultContainer.querySelector(".result__compare-at-price")
			const resultLink = resultContainer.querySelector(".result__link")
			const resultInput = resultContainer.querySelector(`input[name="productSelection"]`)
			const resultLabel = resultContainer.querySelector(".productSelection")

			const variants = product.variants || []
			let avgPrice = variants.length > 0 ? parseFloat(variants[0].price) || 0 : 0

			if (variants.length > 1) {
				const totalVariantsPrice = variants.reduce((total, variant) => total + (parseFloat(variant.price) || 0), 0)

				if ((totalVariantsPrice / variants.length) > avgPrice) {
					avgPrice = (totalVariantsPrice / variants.length).toFixed(2)
				}
			}

			if (resultImage) {
				resultImage.src = product.images[0]?.src || ""
				resultImage.alt = product.title
			}
			if (resultTitle) resultTitle.textContent = product.title
			if (resultHandle) resultHandle.textContent = product.handle
			if (resultPrice) {
				resultPrice.textContent = `₹ ${avgPrice}` || "N/A"
				resultPrice.setAttribute("data-price", avgPrice || "0")
			}
			if (resultCompareAtPrice) resultCompareAtPrice.textContent = `₹ ${parseInt(variants[0].compare_at_price, 10) || 0}`
			if (resultLink) resultLink.href = product.url

			// Link the input and label using product handle
			resultInput.id = product.handle
			resultLabel.setAttribute("for", product.handle)

			const tagsToAdd = []

			if (selectFilters.querySelectorAll("input").length > 1) {

				selectFilters.querySelectorAll("input").forEach((option) => {
					const optionValue = option.value.trim()

					if (product.tags.includes(optionValue)) {
						tagsToAdd.push(optionValue)
					}
				})
			}

			if (tagsToAdd.length > 0) {
				resultContainer.setAttribute("data-filters", tagsToAdd.join(","))
			}
			productListWrapper.appendChild(resultContainer)
		})

		selectButton.classList.remove("hidden")

	} else {
		productListWrapper.innerHTML = "No products found"
		selectButton.classList.add("hidden")
	}

	productListWrapper.parentElement.classList.remove("hidden")
	selectExistingProducts()
}

// Render selected products
function renderProducts(options) {
	for (const option of options) {
		const parent = option.closest(".result")
		const title = parent?.querySelector(".result__title")
		const handle = parent?.querySelector(".result__handle")
		const price = parent?.querySelector(".result__price")

		if (title && handle && price) {
			const productExist = $qs(`.selected_product_title[data-handle="${handle.textContent}"]`)

			if (!productExist) {
				selectedProducts(title, handle, price) // Avoid selecting existing products
			} else {
				updateTotal()
			}
		}
	}

	toggleElements.forEach(ele => ele.classList.remove("hidden"))
	productListWrapper.innerHTML = "" // Clear product list after selection products
}


// Choose Selected Products
function chooseOption(optionValue) {
	return [...$$qsa(optionValue)].filter(option => option.checked)
}

function handleFormSubmit(e) {
	e.preventDefault()

	const formEle = e.target.closest("form")
	const mainForm = formEle.id !== "sendID" // Clear fields when submitting the main form
	const URL = formEle.getAttribute("data-url")
	const formData = new FormData(formEle)
	const params = new URLSearchParams()

	if (mainForm && Object.keys(formFields).some(key => formFields[key].value.trim() === "")) {
		alert("Please select a product before submitting the form.")
		return
	}

	// Disable buttons to prevent multiple submissions
	buttonsToDisable.forEach(button => button ? button.setAttribute("disabled", "true") : null)

	if (sendingAnimation) sendingAnimation.classList.remove("hidden") // Enable sending animation

	if (!mainForm) {
		formData.append("mode", "check") // Send mode parameter. This will be used for extracting matched details from Sheet 2 (User details sheet)
	} else {
		formData.append("uniqueId", $qs("#uniqueId")?.value.trim() || "") // Append UniqueID if available to add it in order details for tracking
	}

	for (const [key, value] of formData.entries()) {
		params.append(key, value)
	}

	fetch(URL, {
		method: "POST",
		body: params
	})
		.then(response => response.json())
		.then(data => {

			if (!data) {
				toggleClasses([messagePopup, errorMessage, backgroundOverlay], false, "hidden")
				if (errorMessage) errorMessage.querySelector("p").textContent = "No response received from the server. Please try again."
				throw new Error("No response data")
			}

			// If the response data in Array format parse it and append the details to Form
			const userDetails = data.userDetails || []
			const orderDetails = data.orderDetails || []

			if (userDetails.length > 0 && editableInputFields.length > 0) {

				userDetails.shift() // Remove the UniqueID field and append other fields

				userDetails.forEach((val, index) => {
					if (editableInputFields[index]) editableInputFields[index].value = val
				})

				// Clear all product details and product input fields
				selectedProductsDetails.innerHTML = ""
				Object.keys(formFields).forEach(key => formFields[key].value = "")

				// Show existing product details if available
				if (orderDetails.length > 0) {

					const handles = orderDetails[0].split("\n")
					const prices = orderDetails[1].split("\n")
					const quantities = orderDetails[2].split("\n")

					updateExistingProductDetails(handles, prices, quantities) // Product handle
				} else {
					console.warn("No order details found in the response.")
					toggleElements.forEach(ele => ele.classList.add("hidden"))
				}
			} else {
				const message = data.message.includes("No match") ? errorMessage : successMessage

				toggleClasses([messagePopup, message, backgroundOverlay], false, "hidden")
				if (message) message.querySelector("p").textContent = data.message
			}
		})
		.catch(error => {
			toggleClasses([messagePopup, errorMessage, backgroundOverlay], false, "hidden")
			if (errorMessage) errorMessage.querySelector("p").textContent = "Submission failed, Please try again"
			console.error(error)
		})
		.finally(() => {

			// Clear all the input fields along with the unique ID field
			if (mainForm) {
				[...inputFields, $qs("#uniqueId")].forEach(input => input.value = "")

				const elementsToEmpty = [selectedProductsDetails, productListWrapper, totalPrice, selectedFilters]
				elementsToEmpty.forEach(ele => ele.innerHTML = "")

                // Clear filters
				selectFilters.querySelectorAll("input:checked").forEach(option => option.checked = false)
				selectFilters.removeAttribute("open")

				toggleClasses([selectButton, selectedList, productListWrapper.parentElement, selectedFilters.parentElement], true, "hidden")

				selectCollections.querySelector("option[data-default]").selected = true // Select default option
			}

            // Hide popup after a delay
			setTimeout(() => {
				toggleClasses([backgroundOverlay, messagePopup, successMessage, errorMessage], true, "hidden")
			}, 2500)

			toggleClasses([sendingAnimation], true, "hidden")

			buttonsToDisable.forEach(button => button ? button.removeAttribute("disabled") : null)
		})
}

// Update selected products values
function selectedProducts(title, handle, price) {
	const clone = template.content.cloneNode(true).querySelector(".selected__result")
	const priceEle = clone.querySelector(".selected_product_price")

	clone.querySelector(".selected_product_title").textContent = title.textContent
	clone.querySelector(".selected_product_title").setAttribute("data-handle", handle.textContent || "")
	clone.querySelector(".selected_product_quantity").value = 1
	priceEle.textContent = `₹ ${parseFloat(price.getAttribute("data-price")) || 0}`
	priceEle.setAttribute("data-unit-price", parseFloat(price.getAttribute("data-price")) || 0)
	priceEle.setAttribute("data-total-price", parseFloat(price.getAttribute("data-price")) || 0)

	selectedProductsDetails.appendChild(clone)

	updateTotal()
}

// If user has existing products in sheet, update those values
function updateExistingProductDetails(handles, prices, quantities) {

	// Validate input arrays
	if (!Array.isArray(handles) || !Array.isArray(prices) || !Array.isArray(quantities)) {
		console.error('Invalid input: expected arrays for handles, prices, and quantities')
		return
	}

	toggleElements.forEach(ele => ele.classList.remove("hidden"))

	handles.forEach((handle, index) => {

		const clone = template.content.cloneNode(true).querySelector(".selected__result")
		const priceEle = clone.querySelector(".selected_product_price")
		const priceStr = prices[index] || '0'
		const quantityStr = quantities[index] || 'Qty - 1'
		const quantity = Math.max(1, parseInt(quantityStr.replace(/^Qty\s*-?\s*/i, "").trim()) || 1)
		const validPrice = Math.max(0, parseFloat(priceStr.replace(/₹/g, "").trim()) || 0)

		clone.querySelector(".selected_product_title").textContent = handle || 'Unknown Product'
		clone.querySelector(".selected_product_title").setAttribute("data-handle", handle || "")
		clone.querySelector(".selected_product_quantity").value = quantity

		priceEle.textContent = `₹ ${(validPrice * quantity).toFixed(2)}`
		priceEle.setAttribute("data-unit-price", validPrice)
		priceEle.setAttribute("data-total-price", (validPrice * quantity).toFixed(2))

		selectedProductsDetails.appendChild(clone)
	})

	updateTotal()
	selectExistingProducts()
}

// Update total price of selected products
function updateTotal() {
	const priceElements = document.querySelectorAll(".selected_product_price")

	let value = 0
	priceElements.forEach(priceEl => {
		value += (parseFloat(priceEl.getAttribute("data-total-price")) || 0)
	})

	totalPrice.textContent = `Total ₹ ${value.toFixed(2)}`
	totalPrice.setAttribute("data-total", value.toFixed(2))

	appendProductDetailsToForm()
}

// Quantity selector and its functions
class QuantitySelector extends HTMLElement {
	constructor() {
		super()

		this.minus = this.querySelector(".minus")
		this.plus = this.querySelector(".plus")
		this.input = this.querySelector(".selected_product_quantity")
		this.delete = this.closest(".product__info").querySelector(".delete")
		this.parent = this.closest(".selected__result")
		this.priceEl = this.parent.querySelector(".selected_product_price")
		this.unitPrice = parseFloat(this.priceEl.dataset.unitPrice)

		this.minus.addEventListener("click", () => this._decreaseQty())
		this.plus.addEventListener("click", () => this._increaseQty())
		this.delete.addEventListener("click", () => this._deleteRecord())
		this.input.addEventListener("change", () => this._updatePriceDisplay())
	}

	_decreaseQty() {
		if (this.input.value > 1) this.input.stepDown()
		this._updatePriceDisplay()
	}

	_deleteRecord() {
		const ele = this.parent.querySelector(".selected_product_title")
		this._uncheckProduct(ele)
		this.parent.remove()
		this._updateTotalPrice()
	}

	_increaseQty() {
		this.input.stepUp()
		this._updatePriceDisplay()
	}

	_uncheckProduct(ele) {
		const results = $$qsa(".result__handle") || []
		const matchedHandle = Array.from(results).find(result => result.textContent === ele.dataset.handle)

		if (matchedHandle) {
			matchedHandle.closest(".result").querySelector("input.productOption").checked = false
			matchedHandle.closest(".result").querySelector("input.productOption").removeAttribute("auto-checked")
		}
	}

	_updateTotalPrice() {
		const priceElements = document.querySelectorAll(".selected_product_price")
		let value = 0
		priceElements.forEach(priceEl => {
			value += (parseFloat(priceEl.getAttribute("data-total-price")) || 0)
		})

		totalPrice.textContent = `Total ₹ ${value.toFixed(2)}`
		totalPrice.setAttribute("data-total", value.toFixed(2))

		const toggleValue = priceElements.length === 0

		toggleElements.forEach(ele => ele.classList.toggle("hidden", toggleValue))

		appendProductDetailsToForm()
	}

	_updatePriceDisplay() {
		const quantity = Math.max(1, parseInt(this.input.value, 10) || 1)
		this.input.value = quantity // Ensure the quantity is greater than 0

		const newPrice = (this.unitPrice * quantity).toFixed(2)
		this.priceEl.textContent = `₹ ${newPrice}`
		this.priceEl.setAttribute("data-total-price", newPrice)

		this._updateTotalPrice() // Update Total
	}
}

customElements.define("quantity-selector", QuantitySelector)

// Append selected products details to the form fields
function appendProductDetailsToForm() {

	const getTextValues = (selector, isInput = false) => {
		return Array.from($$qsa(selector)).map(ele => isInput ? `Qty - ${ele.value.trim()}` : ele.textContent.trim()).join(",")
	}

	const getDatasetValues = (selector, currency = false) => {
		return Array.from($$qsa(selector)).map(ele => currency ? `₹ ${ele.dataset.unitPrice.trim()}` : `${ele.dataset.handle.trim()}`).join(",")
	}

	if (formFields.price) formFields.price.value = getDatasetValues(".selected_product_price", true)
	if (formFields.product) formFields.product.value = getDatasetValues(".selected_product_title")
	if (formFields.quantity) formFields.quantity.value = getTextValues(".selected_product_quantity", true)
	if (formFields.total) formFields.total.value = `₹ ${totalPrice.getAttribute("data-total").trim()}`
}

// Toggle class values
function toggleClasses(elements, toggle, classValue) {
	elements.forEach(ele => { if (ele) toggle ? ele.classList.add(classValue) : ele.classList.remove(classValue) })
}

// Check existing product and select them
function selectExistingProducts() {
	const existingProducts = $$qsa(".selected_product_title")
	const currentCollectionProds = $$qsa(".result__handle")

	if (currentCollectionProds.length > 0 && existingProducts.length > 0) {
		for (const prod of existingProducts) {
			const handle = prod.getAttribute("data-handle")

			if (handle) {
				const matchedproduct = Array.from(currentCollectionProds).find(ele => ele.textContent === handle)

				if (matchedproduct) {
					const input = matchedproduct.closest(".result").querySelector("input.productOption")

					if (input && !input.hasAttribute("auto-checked")) {
						input.checked = true
						input.setAttribute("auto-checked", "")
					}
				}
			}
		}
	}
}